import Papa from 'papaparse';
import type { StudentListRow } from '../../school_panel/api/types';
import { guardRows } from '../../school_panel/lib/csv';

// Spec §8.3 — Students-list CSV export (selected rows, else filtered rows).
export function buildStudentsCsv(rows: StudentListRow[]): string {
  return Papa.unparse({
    fields: [
      'id', 'first_name', 'last_name', 'username', 'grade', 'section',
      'risk_band', 'risk_score', 'engagement', 'open_alerts', 'last_active',
    ],
    data: guardRows(rows.map((r) => [
      r.id,
      r.first_name,
      r.last_name,
      r.username,
      r.grade_name ?? '',
      r.section?.display ?? '',
      r.risk_band,
      r.risk_score ?? '',
      r.engagement_dot,
      r.open_alerts_count,
      r.last_active_at ?? '',
    ])),
  });
}
